import React from 'react';
import { DefaultButton, getTheme, PrimaryButton, Stack, Text } from '@fluentui/react';
import IvicosStrings from 'kits/language/stringKit';

export interface ISessionTakeoverScreenProps {
    variant: 'replaced' | 'open-elsewhere' | 'in-call';
    onPrimary: () => void;
    onSecondary?: () => void;
}

const COPY = {
    replaced: () => ({
        title: IvicosStrings.sessionTakeoverReplacedTitle,
        text: IvicosStrings.sessionTakeoverReplacedText,
        primary: IvicosStrings.sessionTakeoverUseHereButton,
        secondary: undefined
    }),
    'open-elsewhere': () => ({
        title: IvicosStrings.sessionTakeoverOpenElsewhereTitle,
        text: IvicosStrings.sessionTakeoverOpenElsewhereText,
        primary: IvicosStrings.sessionTakeoverUseHereButton,
        secondary: IvicosStrings.sessionTakeoverKeepOtherButton
    }),
    'in-call': () => ({
        title: IvicosStrings.sessionTakeoverInCallTitle,
        text: IvicosStrings.sessionTakeoverInCallText,
        primary: IvicosStrings.sessionTakeoverContinueButton,
        secondary: IvicosStrings.sessionTakeoverCancelButton
    })
};

/** Full-page screen shown instead of Campus while another tab or device holds the user's session, or while asking whether to take over. */
const SessionTakeoverScreen: React.FC<ISessionTakeoverScreenProps> = ({ variant, onPrimary, onSecondary }) => {
    const theme = getTheme();
    const copy = COPY[variant]();

    return (
        <Stack horizontalAlign="center" verticalAlign="center" style={{ height: '100vh', padding: 16 }} aria-label={`session-takeover-${variant}`}>
            <Stack tokens={{ childrenGap: 12 }} style={{ maxWidth: 450, textAlign: 'center' }}>
                <Text variant="xLarge" block>
                    {copy.title}
                </Text>
                <Text variant="medium" block>
                    {copy.text}
                </Text>
                <Stack horizontal horizontalAlign="center" tokens={{ childrenGap: 8 }}>
                    <PrimaryButton
                        aria-label="session-takeover-primary"
                        text={copy.primary}
                        onClick={onPrimary}
                        styles={{ root: { backgroundColor: theme.palette.themePrimary, borderColor: theme.palette.themePrimary } }}
                    />
                    {copy.secondary && onSecondary && <DefaultButton aria-label="session-takeover-secondary" text={copy.secondary} onClick={onSecondary} />}
                </Stack>
            </Stack>
        </Stack>
    );
};

export default SessionTakeoverScreen;
